import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface VirusTrendReq {
  /** 开始时间，时间戳(秒) */
  start_time: number
  /** 结束时间，时间戳(秒) */
  end_time: number
  /** 时间粒度，hour-按小时,day-按天 */
  granularity?: string
}

export interface VirusTrendRes {
  /** 时间点列表 */
  time_points: number[]
  /** 未处理病毒数列表 */
  untreated_counts: number[]
}

@Injectable()
export class VirusTrendChartService {
  constructor (private http: Http) {}

  @InvokeThrottle()
  getVirusTrend (data: VirusTrendReq) {
    return this.http.post<VirusTrendRes>('/safemonitor/virus-scan/trend', data)
  }
}

